<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive include="MediaView">
      <component :is="Component" :key="route.name === 'media-platform' ? `media-${String(route.params.platform)}` : route.fullPath" />
    </keep-alive>
  </router-view>
  <AppDialogHost />
  <AppToastHost />
</template>

<script setup lang="ts">
import AppDialogHost from '@/components/common/AppDialogHost.vue'
import AppToastHost from '@/components/common/AppToastHost.vue'
</script>
